{
  "END_USER": "Endbenutzer",
  "MFA_REQUIRED": "Mfa erforderlich",
  "COMPANY_INFORMATION": "Firmeninformation",
  "COMPANY_NAME": "Firmenname",
  "ADDRESS1": "Straße",
  "ADDRESS2": "Adresse",
  "ZIP": "Postleitzahl",
  "CITY": "Stadt",
  "ORG_NUMBER": "Steuernummer",
  "EMAIL_ADDRESS": "Email",
  "TELEPHONE": "Telefonnr.",
  "WEBADDRESS": "Webseite",
  "QUOTATION": "Angebot",
  "NAME": "Name",
  "CUSTOMER": "Kunde",
  "YOUR_REFERENCE": "Ihre Referenz",
  "PAYMENT_TERMS": "Zahlungsbedingungen",
  "DATE": "Datum",
  "EXPIRE_DATE": "Gültig bis",
  "OUR_REFERENCE": "Unsere Referenz",
  "DELIVERY_TERMS": "Lieferbedingungen",
  "NOTES": "Kommentare",
  "PRICE_SUMMARY": "Übersicht",
  "ART_NO": "Art. Nr.",
  "DESCRIPTION": "Beschreibung",
  "QUANTITY": "Anzahl",
  "PRICE": "Preis",
  "DISCOUNT": "Rabatt",
  "DISCOUNTED_PRICE": "Rabattierter Preis",
  "TOTAL_PRICE": "Gesamtpreis",
  "TOTAL_PRICE_AFTER_DISCOUNT": "Gesamtpreis nach Rabatt",
  "NEW_PRODUCTS": "Neue Produkte",
  "MY_ACCOUNT": "Mein Konto",
  "PRICE_LIST": "Preisliste",
  "PARTIAL_DELIVERY_EXPECTED": "Teillieferung, erste Lieferung {{date}}",
  "ENTRY_IN_PROGRESS": "Eingang in Bearbeitung",
  "ENTERED": "Eingegeben",
  "PICKING_IN_PROGRESS": "Kommissionierung in Bearbeitung",
  "INVOICED": "Rechnung gestellt",
  "TOP_PRODUCTS": "Top-Produkte",
  "NOT_ADD_BROCHURES": "I do not want brochures",
  "ADD_BROCHURES": "Add brochures",
  "BROCHURES_DECISION_NECESSARY": "Brochures decision necessary",
  "SPARE_PARTS": "Ersatzteile",
  "TOTAL_VAT_INCLUDED": "Gesamtbetrag inkl. MwSt.: ",
  "VAT_PRECENTAGE": "MwSt. %",
  "VAT_VALUE": "MwSt-Wert: ",
  "SAVE_AND_EMAIL_QUOTATION": "Speichern und E-Mail senden",
  "TO_BE_PHASED_OUT": "Wird schrittweise eingestellt",
  "TARIFF_CODE": "Tarifcode",
  "REPLACES_NUMBER": "Ersetzt Nummer",
  "REPLACES_PRODUCT": "Ersetzt das Produkt",
  "NEWS_BANNER": "Neu",
  "CAMPAIGN_UNTIL": "Kampagne bis",
  "NEW_PRICE_FROM": "Neuer Preis ab",
  "PRESELECTED_CUSTOMER_ID": "Vorausgewählte Kunden-ID",
  "CHANGE_ACCOUNT": "Konto wechseln",
  "CONTACT_YOUR_SALES_REPRESENTATIVE": "Kontaktieren Sie Ihren Vertriebsmitarbeiter"
}
